import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "About" */ './views/About.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/how-we-work',
      name: 'how-we-work',
      component: () => import(/* webpackChunkName: "HowWeWork" */ './views/HowWeWork.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import(/* webpackChunkName: "contact" */ './views/Contact.vue'),
    },
    {
      path: '/insights',
      name: 'insights',
      component: () => import(/* webpackChunkName: "insight" */ './views/Insights.vue'),

    },
    {
      path: '/insights/:post',
      name: 'post',
      component: () => import(/* webpackChunkName: "insight" */ './views/Post.vue'),
    },
    {
      path: '/affiliates',
      name: 'affiliates',
      component: () => import(/* webpackChunkName: "affiliates" */ './views/Affiliates.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/:legal(terms-of-use|privacy)',
      name: 'legal',
      component: () => import(/* webpackChunkName: "LegalPrivacy" */ './views/LegalPrivacy.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/protected/:password',
      name: 'protected',
      component: () => import(/* webpackChunkName: "LegalPrivacy" */ './views/Protected.vue'),
    },
  ],
});
